import * as amplitude from "@amplitude/analytics-browser";

const API_KEY = import.meta.env.VITE_AMPLITUDE_API_KEY;
export const AmplitudeService = {
  init() {
    if (!API_KEY) return;

    const isProd = import.meta.env.PROD;

    amplitude.init(API_KEY, {
      defaultTracking: isProd,
    });
  },

  trackEvent(event: string, properties?: Record<string, any>) {
    amplitude.track(event, properties);
  },
};
